module.exports = __webpack_public_path__ + "img/I.49148f3b.png";